._input_e95jl_1 {
  color: var(--text-color);
  cursor: text; }
  ._inputWrapper_e95jl_4 {
    position: relative;
    width: 100%; }
  ._input_e95jl_1 > div:first-child {
    border-radius: 22px !important;
    border: 1px solid transparent !important;
    background: var(--chat-input-bg);
    min-height: 42px;
    display: flex;
    align-items: center;
    outline: none !important;
    box-shadow: none !important; }
    [data-theme="chat-theme-dark"] ._input_e95jl_1 > div:first-child,
    [data-theme="chat-theme-light"] ._input_e95jl_1 > div:first-child {
      min-height: 60px;
      border-radius: 20px !important; }
    [data-theme="chat-theme-light"] ._input_e95jl_1 > div:first-child {
      box-shadow: 0px 6px 24px 0px #00062414 !important; }
    [data-theme="chat-theme-dark"] ._input_e95jl_1 > div:first-child {
      box-shadow: 0px 10px 24px 0px #00000033 !important; }

@container chat (max-width: 470px) {
  ._input_e95jl_1 > div:first-child {
    padding-left: 24px !important; }
    [data-theme="chat-theme-dark"] ._input_e95jl_1 > div:first-child,
    [data-theme="chat-theme-light"] ._input_e95jl_1 > div:first-child {
      min-height: 54px; } }
  ._input_e95jl_1 textarea {
    padding: 0 !important;
    padding: 8px 60px 8px 24px !important;
    caret-color: var(--input-caret);
    color: var(--text-color) !important;
    overflow-y: hidden; }

@container chat (max-width: 470px) {
  ._input_e95jl_1 textarea {
    padding: 0 !important;
    margin-right: 50px !important;
    max-height: 92px !important;
    min-height: 20px !important;
    overflow-y: hidden;
    font-size: var(--text-font-size-slim) !important;
    line-height: 20px !important; } }
    [data-theme="chat-theme-dark"] ._input_e95jl_1 textarea::placeholder {
      color: #9C9CA2; }
  ._inputDisabled_e95jl_49 > div:first-child {
    background: var(--chat-input-bg-disabled) !important; }
  [data-theme="chat-theme-dark"] ._inputDisabled_e95jl_49 textarea::placeholder {
    color: #515254; }

._input_e95jl_1:hover > div:first-child,
._input-focused_e95jl_55 > div:first-child {
  background: var(--chat-input-bg-focus); }

._button_e95jl_58 {
  position: absolute;
  right: 5px;
  bottom: 4px;
  width: 33px !important;
  height: 34px !important;
  border-radius: 50% !important;
  padding: 0;
  border: none !important;
  background: var(--chat-input-button-bg-color);
  transition: opacity 0.2s ease-in-out !important; }
  [data-theme="chat-theme-dark"] ._button_e95jl_58,
  [data-theme="chat-theme-light"] ._button_e95jl_58 {
    width: 42px !important;
    height: 42px !important;
    border-radius: 15px !important;
    bottom: 9px;
    right: 9px; }

@container chat (max-width: 470px) {
  [data-theme="chat-theme-dark"] ._button_e95jl_58,
  [data-theme="chat-theme-light"] ._button_e95jl_58 {
    width: 36px !important;
    height: 36px !important;
    bottom: 9px;
    right: 9px;
    border-radius: 12px !important; } }
  ._button_e95jl_58._empty_e95jl_85 {
    cursor: default; }
    [data-theme="chat-theme-original"] ._button_e95jl_58._empty_e95jl_85 {
      opacity: 0.4; }
    [data-theme="chat-theme-light"] ._button_e95jl_58._empty_e95jl_85 {
      background: #DFE5EB; }
    [data-theme="chat-theme-dark"] ._button_e95jl_58._empty_e95jl_85 {
      background: #515254; }
      [data-theme="chat-theme-dark"] ._button_e95jl_58._empty_e95jl_85 path {
        fill: #353639; }
  ._button_e95jl_58 svg {
    width: 14px;
    height: 13px; }
  ._button_e95jl_58 path {
    fill: var(--chat-input-icon-fill); }

._clickCatcher_e95jl_101 {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 2; }
